var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_16873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3999 11.0232C22.4057 11.6661 21.8893 12.1911 21.246 12.1964L20.218 12.2053C20.0783 16.7945 17.712 20.5392 14.649 21.1554L14.6834 25.2022C14.6887 25.8454 14.1723 26.3704 13.5291 26.3758C12.8858 26.3804 12.3612 25.8644 12.3551 25.2211L12.3209 21.0099C9.54859 20.09 7.42745 16.5843 7.22565 12.3108L6.19911 12.3197C5.55585 12.3251 5.03084 11.8087 5.02512 11.1651C5.02093 10.5229 5.53693 9.9983 6.17942 9.99144L8.8164 9.97033L8.77843 5.39369C8.77347 4.75005 9.2891 4.2258 9.93235 4.22046C10.576 4.21474 11.1002 4.73036 11.1056 5.37438L11.1432 9.95141L15.9512 9.91153L15.9133 5.33488C15.9079 4.69086 16.4239 4.16623 17.0676 4.16127C17.7101 4.15595 18.2355 4.6727 18.2404 5.31482L18.2784 9.89222L21.2252 9.86778C21.87 9.86319 22.3946 10.3792 22.3999 11.0232Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_16873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.0654297 13.6113) rotate(-45.4753)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingIcon);
export default __webpack_public_path__ + "static/media/charging-icon.b2e9e258a3dd6244d500e8d2b67e9911.svg";
export { ForwardRef as ReactComponent };